/*
 * FeatureNav
 *
 * A helper library to mutate left and top navigation from a Vue feature VM
 *
 * JS Usage:
 *
 *      new FeatureNav(this.$bus);
 */
export default function($bus) {
  let self = this;
  self.top_nav_items = [];
  self.left_nav_items = [];

  /**
   * Renders left nav
   * @param {Object[]} nav_items - eg: {icon_class: 'kf-coursework', label: 'Add Section', is_active: this.isActive, callback: function () { console.log('Add Section') }}
   */
  self.renderLeftNav = function (nav_items) {
    self.left_nav_items = nav_items;
    $bus.$emit('left_nav_render', { nav_items });
  };

  self.clearLeftNav = function () {
    self.left_nav_items = [];
    $bus.$emit('left_nav_clear');
  };

  self.hideExpandArrow = function(expandable) {
    $bus.$emit('hide_expand_arrow');
  };

  /**
   * Renders top nav
   * @param {Object} primary_action - eg: {label: 'Publish', is_active: this.isActive, callback: function () { console.log('PUBLISH') }}
   * @param {Object[]} nav_items - eg: {label: 'General Info', caption: '', is_active: this.isActive, callback: function () { console.log('General Info') }
   */
  self.renderTopNav = function (primary_action, nav_items) {
    self.top_nav_items = nav_items;
    $bus.$emit('top_nav_render', {primary_action: primary_action, nav_items: nav_items});
  };


  self.clearTopNav = function () {
    self.top_nav_items = [];
    $bus.$emit('top_nav_clear');
  };

  /**
   * Sets active state of a nav item
   * @param {String} nav_type - 'left' or 'top'
   * @param {Number} index
   * @return {Boolean} is_active
   */
  self.setActiveState = function (nav_type, index, is_active) {
    const nav_items = _.map(new Array(self[`${nav_type}_nav_items`].length), function(o, i) { return i === index ? { is_active } : {is_active: !is_active}; });
    $bus.$emit(`${nav_type}_nav_update`, { nav_items });
  };

  self.setPrimaryActiveState = function (is_active) {
    $bus.$emit('top_nav_update', {primary_action: { is_active }});
  };

  const __construct = function(that) {
    console.log('constructor called for FeatureNav');

  }(this);
}

